import {
    queryClient,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";

import {
    getGetUsersUserIdAssignmentCountQueryKey,
    useGetUsersUserIdAssignmentCountSuspense,
} from "api/generated/users/users";

export function useAssignmentCountQuery(userId: string) {
    return useGetUsersUserIdAssignmentCountSuspense(Number(userId), {
        query: {
            select: (data) => data.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}

export function invalidateAssignmentCountQuery(userId: string) {
    return queryClient.invalidateQueries({
        queryKey: getGetUsersUserIdAssignmentCountQueryKey(Number(userId)),
    });
}
